import { render, staticRenderFns } from "./JobStatusChip.vue?vue&type=template&id=38f50aca&scoped=true"
import script from "./JobStatusChip.vue?vue&type=script&lang=js"
export * from "./JobStatusChip.vue?vue&type=script&lang=js"
import style0 from "./JobStatusChip.vue?vue&type=style&index=0&id=38f50aca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f50aca",
  null
  
)

export default component.exports